export default __webpack_public_path__ + "static/media/CEDIA-Pesca.a2e242b2.jpeg";